import { cardeal } from './api';

export class ReservaMatematicaService {
  getReservaPlanoA = async (matricula, plano) => {
    const response = await cardeal.get('ObterReservaMatematicaComum', {
      params: {
        matricula,
        plano,
      },
    });
    return {
      reserva: response.data.ObterReservaMatematicaResult.VR_RES_MAT,
      referencia: response.data.ObterReservaMatematicaResult.DT_Vig,
    };
  };

  setReservaPlanoA = async (matricula) => {
    const response = await cardeal.post('InserirReservaPlanoA', {
      matricula,
    });

    return response.data.sucesso;
  };
}
